import { FC, useState } from 'react';
import { Button, Menu } from '@mantine/core';
import classnames from 'classnames';
import { useNavigate, useLocation } from 'react-router-dom';

// internal
import {
  activityAdmin,
  clientAdmin,
  clientViewer,
  clientWriter,
  roleAdmin,
  roleViewer,
  roleWriter,
  settingAdmin,
  settingViewer,
  settingWriter,
  userAdmin,
  userViewer,
  userWriter,
} from 'constants/permission';
import { Permission } from 'apps/composer-app/src/components/auth/PermissionCheck';

const menu = {
  audit: '/main/audit',
  project: '/main/project',
  user_manage: '/main/user/manage',
  user_role: '/main/user/role',
  partner: '/main/partner',
  client: '/main/client',
  setting_general: '/main/setting/general',
  setting_integration: '/main/setting/integration',
  setting_whitelist: '/main/setting/whitelist',
  setting_authentication: '/main/setting/authentication',
  console: '/console',
};

const MainMenu: FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [openedMenuUser, setOpenedMenuUser] = useState(false);
  const [openedMenuSetting, setOpenedMenuSetting] = useState(false);

  const onClickMenu = (path: string) => {
    navigate(path);
  };

  return (
    <div className="flex w-full p-3 bg-headerBar">
      <div className="mx-4">
        <Button
          variant="subtle"
          radius="xl"
          className={classnames({ 'border border-primary bg-white font-bold': location.pathname === menu.project })}
          onClick={() => onClickMenu(menu.project)}
        >
          Project
        </Button>
      </div>

      <Permission resources={[]}>
        <div className="mx-4">
          <Button
            variant="subtle"
            radius="xl"
            className={classnames({ 'border border-primary bg-white font-bold': location.pathname === menu.console })}
            onClick={() => onClickMenu(menu.console)}
          >
            Console
          </Button>
        </div>
      </Permission>

      {/* {permissionStore.partnerViewer && (
        <div className="mx-4">
          <Button
            variant="subtle"
            radius="xl"
            className={classnames({ 'border border-primary bg-white font-bold': location.pathname === menu.partner })}
            onClick={() => onClickMenu(menu.partner)}
          >
            Partner
          </Button>
        </div>
      )} */}

      <Permission resources={[]}>
        <div className="mx-4">
          <Button
            variant="subtle"
            radius="xl"
            className={classnames({ 'border border-primary bg-white font-bold': location.pathname === menu.client })}
            onClick={() => onClickMenu(menu.client)}
          >
            Client
          </Button>
        </div>
      </Permission>

      <Permission resources={[userViewer, userWriter, userAdmin, roleViewer, roleWriter, roleAdmin]}>
        <div className="mx-4">
          <Menu
            shadow="md"
            radius="lg"
            classNames={{ dropdown: 'border border-primary rounded-tl-none' }}
            offset={0}
            width={150}
            position="bottom-start"
            opened={openedMenuUser}
            onChange={setOpenedMenuUser}
          >
            <Menu.Target>
              <Button
                variant="subtle"
                radius="xl"
                className={classnames({
                  'border border-primary bg-white  font-bold':
                    location.pathname === menu.user_manage || location.pathname === menu.user_role,
                  'border border-primary rounded-bl-none rounded-br-none bg-white rounded-2xl font-bold':
                    openedMenuUser,
                })}
              >
                Users
              </Button>
            </Menu.Target>
            <Menu.Dropdown>
              <Permission resources={[userViewer, userWriter, userAdmin]}>
                <Menu.Item className="text-primary" onClick={() => onClickMenu(menu.user_manage)}>
                  Manage
                </Menu.Item>
              </Permission>

              <Permission resources={[roleViewer, roleWriter, roleAdmin]}>
                <Menu.Item className="text-primary" onClick={() => onClickMenu(menu.user_role)}>
                  Role
                </Menu.Item>
              </Permission>
            </Menu.Dropdown>
          </Menu>
        </div>
      </Permission>

      <Permission resources={[activityAdmin]}>
        <div className="mx-4">
          <Button
            variant="subtle"
            radius="xl"
            className={classnames({ 'border border-primary bg-white font-bold': location.pathname === menu.audit })}
            onClick={() => onClickMenu(menu.audit)}
          >
            Audit Logs
          </Button>
        </div>
      </Permission>

      <Permission resources={[settingViewer, settingWriter, settingAdmin]}>
        <div className="mx-4">
          <Menu
            shadow="md"
            radius="lg"
            classNames={{ dropdown: 'border border-primary rounded-tl-none' }}
            offset={0}
            width={150}
            position="bottom-start"
            opened={openedMenuSetting}
            onChange={setOpenedMenuSetting}
          >
            <Menu.Target>
              <Button
                variant="subtle"
                radius="xl"
                className={classnames({
                  'border border-primary rounded-bl-none rounded-br-none bg-white rounded-2xl font-bold':
                    openedMenuSetting,
                })}
              >
                Setting
              </Button>
            </Menu.Target>
            <Menu.Dropdown>
              <Menu.Item className="text-primary" onClick={() => onClickMenu(menu.setting_general)}>
                General
              </Menu.Item>

              <Permission resources={[]}>
                <Menu.Item className="text-primary" onClick={() => onClickMenu(menu.setting_integration)}>
                  Integration
                </Menu.Item>
                <Menu.Item className="text-primary" onClick={() => onClickMenu(menu.setting_whitelist)}>
                  Whitelist
                </Menu.Item>
              </Permission>
              <Permission resources={[settingAdmin]}>
                <Menu.Item className="text-primary" onClick={() => onClickMenu(menu.setting_authentication)}>
                  Authentication
                </Menu.Item>
              </Permission>
            </Menu.Dropdown>
          </Menu>
        </div>
      </Permission>
    </div>
  );
};

export default MainMenu;
